import * as Yup from 'yup'

export const validationSchema = () => (
  Yup.object().shape({
    altText: Yup.string().required('Alt text is required')
      .max(255, 'Alt Text must be at most 255 characters'),
  })
)
